<template>
  <div class="main-page">
    <div v-if="events != null">
      <div class="video-chat-section">
        <div class="video-wrapper">
          <div class="video-wrapper__above">
            <b> </b>
          </div>
          <Video
            v-if="activeEvent"
            v-model="activeEvent"
            :key="[activeEvent.vimeo_id, activeEvent.youtube_id].join('_')"
            :first-start-at="firstStartAt"
          />
          <div class="video-wrapper__below">
            <div
              class="active-event"
              v-if="displayEvent && !displayEvent.hidden"
            >
              <div class="active-event__left">
                <div class="active-event__content">
                  {{ displayEvent.title }}
                </div>
                <div class="active-event__subtitle">
                  <span>
                    <span
                      v-for="genre in displayEvent.genres"
                      :key="genre.id"
                      >{{ genre.name }}</span
                    ></span
                  >
                  <span v-if="displayEvent.captain_name">{{
                    displayEvent.captain_name
                  }}</span>
                  <span v-if="displayEvent.school">{{
                    displayEvent.school.name
                  }}</span>
                </div>
                <div
                  class="active-event__gta_winner"
                  v-if="displayEvent.gta_winner"
                >
                  <span
                    class="schedule-item__tag"
                    v-for="item in splitGtaWinner(displayEvent.gta_winner)"
                    :key="item"
                  >
                    {{ item }}</span
                  >
                </div>
                <div
                  class="active-event__gta_winner"
                  v-if="displayEvent.partner_winner"
                >
                  <span
                    class="schedule-item__tag"
                    v-for="item in splitPartnerWinner(
                      displayEvent.partner_winner
                    )"
                    :key="item"
                  >
                    {{ item }}</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-show="chat && !chat.hidden"
          v-if="$size != 'xs'"
          class="chat-wrapper"
        >
          <Chat v-model="chat" :reciever="true" />
        </div>
      </div>

      <div v-show="chat && !chat.hidden">
        <div class="show-chat" @click="showChat = !showChat">
          {{ showChat ? "Hide" : "Show" }} Chat
          <v-btn
            color="white"
            class="btn-icon btn-icon-toggle"
            :size="btnSize"
            :x-small="btnSize == 'x-small'"
            :large="btnSize == 'large'"
          >
            <v-icon color="cmf_darkgrey" :class="{ opened: showChat }"
              >$cmf_caret</v-icon
            >
          </v-btn>
        </div>
        <div
          v-if="$size == 'xs'"
          class="chat-wrapper"
          :class="{ opened: showChat }"
        >
          <Chat v-model="chat" />
        </div>
      </div>

      <div
        class="timeline-rotator-section"
        v-if="events && events.length > 0"
        :class="{
          'timeline-rotator-section--align-title':
            activeEvent && !activeEvent.hidden,
          'only-hidden-events': hideTimeline()
        }"
      >
        <div class="timeline-rotator-section__info">
          <b>
            Select a thumbnail below to watch posted content. Click the left
            arrow to see pieces posted earlier.
          </b>
          <div>
            <i>
              Note: you can also scroll down the page to view archived content.
              Unfortunately, by policy of the Equal Justice Initiative, we are
              unable to continue to share the keynote address by Bryan
              Stevenson.
            </i>
          </div>
        </div>
        <TimelineRotator
          v-model="activeEventId"
          v-if="events"
          :slides="events"
          :hideTimeline="false"
          :displayValue="displayEventId"
        />
      </div>

      <div
        class="articles-section articles-section-top-most"
        v-if="topMostArticleSections && topMostArticleSections.length > 0"
      >
        <ArticleSection
          :section="articleSection"
          v-for="articleSection in topMostArticleSections"
          :key="articleSection.id"
        />
      </div>

      <slot name="gridlinks" />

      <div
        class="articles-section articles-section-top"
        v-if="topArticleSections && topArticleSections.length > 0"
      >
        <ArticleSection
          :section="articleSection"
          v-for="articleSection in topArticleSections"
          :key="articleSection.id"
        />
      </div>

      <slot name="main"></slot>

      <div v-if="noResults" class="no-results">Nothing found</div>

      <div
        class="articles-section"
        v-if="articleSections && articleSections.length > 0"
      >
        <ArticleSection
          :section="articleSection"
          v-for="articleSection in articleSections"
          :key="articleSection.id"
          :shuffle-articles="shuffleArticles"
        />
      </div>
    </div>
    <Spinner v-else />

    <v-snackbar
      v-if="newVideo"
      class="new-video"
      v-model="newVideo"
      @click="newVideo = false"
      :timeout="600000"
      top
    >
      <div @click="setNewEvent" class="new-video__text">
        <span> New event starting </span>
        <v-icon color="#e80000">$arrow_right</v-icon>
      </div>
      <div class="new-video__close" @click="newVideo = false">close</div>
    </v-snackbar>
  </div>
</template>

<script>
import { mapState } from "vuex";
const UPDATE_WINDOW = Math.floor(Math.random() * 30000);

export default {
  name: "MainPage",
  metaInfo: {
    titleTemplate: "%s"
  },
  props: {
    openArticle: Boolean,
    shuffleArticles: Boolean
  },
  data() {
    return {
      activeEventId: null,
      activeEvent: null,
      displayEvent: null,
      displayEventId: null,
      showChat: false,
      firstTime: true,
      newVideo: false,
      newEvent: null,
      chat: null,
      firstStartAt: 0,
      articleCounts: {},
      noResults: false
    };
  },
  mounted() {
    this.fetchData();

    this.$root.$on("setActiveEvent", event => {
      this.activeEvent = event;
      this.activeEventId = event.id;
      this.displayEvent = this.activeEvent;
      this.displayEventId = this.activeEventId;

      // if (!this.firstTime) {
      //   const y =
      //     document.querySelector(".video-wrapper").getBoundingClientRect().top +
      //     window.scrollY;

      //   window.scroll({
      //     top: y - 60,
      //     behavior: "smooth",
      //   });
      // }
      this.firstTime = false;

      const route = { ...this.$route };
      if (this.activeEvent.type == "article") {
        route.query = {
          article_id: this.activeEvent.id
        };
      } else {
        route.query = {
          event_id: this.activeEvent.id
        };
      }

      this.$router.replace(route);
    });

    this.$root.$on("nextVideo", () => {
      const activeEventIndex = this.events.findIndex(
        t => t.id == this.activeEventId
      );
      const displayEventIndex = this.events.findIndex(
        t => t.id == this.displayEventId
      );
      const index =
        displayEventIndex > activeEventIndex
          ? displayEventIndex
          : activeEventIndex;
      const nextEvent = this.events[index + 1];
      if (index != -1 && nextEvent && nextEvent.posted) {
        this.activeEvent = nextEvent;
        this.activeEventId = nextEvent.id;
        this.displayEvent = this.activeEvent;
        this.displayEventId = this.activeEventId;
      }
    });

    this.$root.$on("chapterChange", data => {
      const index = this.events.findIndex(
        t =>
          t.vimeo_id == data.vimeo_id && t.vimeo_chapter == data.vimeo_chapter
      );
      const event = this.events[index];
      if (index != -1 && event) {
        this.displayEvent = event;
        this.displayEventId = event.id;
      }
    });

    this.$root.$on("articleCountChange", data => {
      this.articleCounts[data.id] = data.count;
      let total = 0;
      Object.keys(this.articleCounts).forEach(k => {
        total += this.articleCounts[k];
      });
      this.noResults = total == 0;
    });
  },
  methods: {
    setNewEvent() {
      this.activeEventId = this.newEvent.id;
      this.activeEvent = this.newEvent;
      this.displayEvent = this.activeEvent;
      this.displayEventId = this.activeEventId;
      this.$root.$emit("slideToEvent", this.displayEventId);
      this.newVideo = false;
    },
    async fetchData() {
      return Promise.all([this.fetchArticles(), this.fetchEvents()]);
    },
    async fetchEvents() {
      const events = await this.fetchResource("Event", this.formatEvents);
      let fetchAt = null;

      for (const event of events) {
        if (!event.ready) {
          fetchAt = new Date(event.start_at);
          break;
        }
      }

      for (const event of events) {
        if (!event.posted) {
          const postAt = new Date(event.start_at);

          const timeout = postAt.getTime() - Date.now();
          if (timeout <= 2147483647) {
            setTimeout(() => {
              this.newVideo = true;
              this.newEvent = event;
              this.updateResource("Event", this.formatEvents, this.events);
            }, timeout);
          }
          break;
        }
      }

      if (fetchAt) {
        const timeout = fetchAt.getTime() - Date.now() - UPDATE_WINDOW;
        if (timeout > 0 && timeout <= 2147483647) {
          this.timeout = setTimeout(() => this.fetchEvents(), timeout);
        }
      }

      this.firstStartAt = Date.parse(
        events.find(event => !event.hidden).start_at
      );
    },
    async fetchArticles() {
      const sections = await this.fetchResource("ArticleSection");
      let fetchAt = null;
      sections.forEach(section => {
        this.articleCounts[section.id] = section.articles.count;
        for (const article of section.articles) {
          if (!article.posted) {
            const newFetchAt = new Date(article.posted_at);
            if (!fetchAt || newFetchAt < fetchAt) {
              fetchAt = newFetchAt;
            }
            break;
          }
        }
      });

      if (fetchAt) {
        const timeout = fetchAt.getTime() - Date.now() + UPDATE_WINDOW;
        if (timeout > 0 && timeout <= 2147483647) {
          this.timeout = setTimeout(async () => {
            await this.fetchArticles();
          }, timeout);
        }
      }
    },
    formatEvents(_events) {
      if (!_events) return null;

      const events = JSON.parse(JSON.stringify(_events));
      const to = events.length - 1;

      for (let i = to; i > 0; i--) {
        events[i].start_at_day = null;
      }

      for (let i = to; i > 0; i--) {
        const posted = new Date() >= new Date(events[i].start_at);

        if (posted) {
          for (let j = i; j > 0; j--) {
            const event = events[j];

            if (event.start_at == events[i].start_at) {
              event.posted = true;
              event.status = "just_posted";
            } else {
              event.status = "earlier";
              break;
            }
          }

          const taggedDates = [];

          for (let j = i + 1; j <= to; j++) {
            const event = events[j];
            const stamp = this.$moment(
              new Date(event.start_at),
              "timezone",
              "America/New_York"
            ).format("MM/DD");

            if (!taggedDates.includes(stamp)) {
              taggedDates.push(stamp);
              event.start_at_day = event.start_at;
            }
          }

          break;
        }
      }
      return events;
    },
    hideTimeline() {
      return this.visibleEvents && this.visibleEvents.length == 0;
    },
    splitGtaWinner(gta_winner) {
      return gta_winner.split(", ").map(g => `Best ${g}`);
    },
    splitPartnerWinner(partner_winner) {
      return partner_winner.split(", ");
    }
  },
  computed: {
    ...mapState({
      events: state => state.page.cache[state.page.active?.id]?.Event,
      visibleEvents: state =>
        state.page.cache[state.page.active?.id]?.Event?.filter(function(e) {
          return !e.hidden;
        }),
      topArticleSections: state =>
        state.page.cache[state.page.active?.id]?.ArticleSection?.filter(
          function(as) {
            return as.position < 0 && as.position >= -100;
          }
        ),
      topMostArticleSections: state =>
        state.page.cache[state.page.active?.id]?.ArticleSection?.filter(
          function(as) {
            return as.position < -100;
          }
        ),
      articleSections: state =>
        state.page.cache[state.page.active?.id]?.ArticleSection?.filter(
          function(as) {
            return as.position >= 0;
          }
        ),
      countdown: state => state.page.cache[state.page.active?.id]?.Countdown
    }),
    btnSize() {
      const btnSize = {
        sm: "x-small",
        xs: "x-small"
      };

      return btnSize[this.$size] || "large";
    }
  },
  beforeDestroy() {
    if (this.timeout) clearTimeout(this.timeout);
  }
};
</script>

<style scoped lang="scss">
@import "@/styles/variables.scss";

.video-chat-section {
  display: flex;
  position: relative;
  border-bottom: 2px solid $primary;

  .video-wrapper {
    width: 100%;

    &__above {
      padding: 20px 60px;
      display: none;
    }
    &__below {
    }
  }

  .chat-wrapper {
    width: 300px;
    min-width: 300px;
  }
}

.chat-wrapper::v-deep {
  .chat {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    width: 300px;
  }
}

.show-chat {
  display: none;
  padding: 20px;
  font-family: $body-font-family, sans-serif;
  font-weight: bold;
  font-size: 16px;
  line-height: 16px;
  letter-spacing: 0.05em;
  color: $cmf-darkgrey;
  border-top: 1px solid #e5e5e5;
  border-bottom: 1px solid #e5e5e5;
}

.timeline-rotator-section {
  border-top: 1px solid #e5e5e5;
  margin-top: -1px;

  &__info {
    display: none;
    padding: 15px 60px;
  }
}

.main-page {
  position: relative;
}

.articles-section {
  padding-bottom: 50px;
  &-top,
  &-top-most {
    border-bottom: solid 2px #34494c;
  }
}

.active-event {
  padding: 20px 34px 20px 120px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: white;
  &__left {
    margin-right: 1.5em;
  }
  &__right {
    font-size: 12px;
    line-height: 15px;
    float: right;
    display: flex;
    align-items: center;
    &__message {
      margin-right: 34px;
      max-width: 220px;
    }
  }

  &__gta_winner {
    margin-top: 0.5em;
  }
}

.active-event__content {
  color: $primary;
  font-weight: 300;
  font-size: 36px;
  line-height: 1.25;
  text-transform: uppercase;
}
.active-event__subtitle {
  color: $primary;
  font-weight: 400;
  font-size: 20px;
  line-height: 1.3;
  > span:not(:last-child):after {
    content: " / ";
  }
  > span > span:not(:last-child):after {
    content: " / ";
  }
}

.only-hidden-events {
  display: none;
}

.no-results {
  text-align: center;
  font-size: 20px;
}

@media screen and (max-width: 1264px) {
  .active-event {
    padding: 20px;
  }
  .timeline-rotator-section {
    padding: 0;

    &__info {
      padding: 15px 85px;
    }
  }
}

@media screen and (max-width: 960px) {
  .chat-wrapper {
    position: relative;
    height: 0px;
    width: 100% !important;
    transition: 0.3s;

    &.opened {
      height: 500px;
      &::v-deep .chat {
        border-color: #e7e7e7;
        opacity: 1;
      }
    }

    &::v-deep .chat {
      width: 100%;
      border-color: transparent;
      border-left: none;
      border-right: none;
      border-top: none;
      transition: 0.3s;
      opacity: 0;
    }
  }

  .show-chat {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .video-chat-section {
    display: block;
  }

  .active-event {
    padding: 20px;

    &__content {
      font-size: 28px;
      margin-bottom: 15px;
    }
    &__subtitle {
      font-size: 18px;
    }
  }
}

.new-video {
  margin-top: -60px;

  &__text {
    font-family: $body-font-family;
    font-weight: 600;
    font-size: 16px;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: $primary;
    display: flex;
    align-items: center;
    height: 100%;
    width: 100%;
    padding-left: 20px;
    cursor: pointer;

    &:hover {
      background: rgba(0, 0, 0, 0.1);
    }

    .v-icon {
      margin: 0 0 0.12em 0.25em;
    }
  }

  &__close {
    font-family: $body-font-family;
    font-weight: 600;
    color: #4a4a4a;
    padding: 0 11px;
    border-left: 1px solid #c4c4c4;
    height: 100%;
    text-align: center;
    cursor: pointer;

    &:hover {
      background: rgba(0, 0, 0, 0.1);
    }
  }

  &::v-deep {
    .v-snack__wrapper {
      background: white;
      border-radius: 20px;
      min-width: 300px;
      overflow: hidden;
      margin: 6px;
    }

    .v-snack__content {
      padding: 0;
    }
  }
}

@media screen and (max-width: 600px) {
  .active-event {
    flex-direction: column;
    align-items: end;
  }
  .active-event__left {
    margin-bottom: 1em;
  }
}
</style>
